import { Monitor, Moon, Sun } from "lucide-react";

import { useTheme } from "@/app/theme/theme.context";
import { Button } from "@/components/ui/button";

const META = {
  claro: { Icono: Sun, label: "Tema claro" },
  oscuro: { Icono: Moon, label: "Tema oscuro" },
  sistema: { Icono: Monitor, label: "Tema del sistema" },
} as const;

/**
 * Toggle de modo claro/oscuro en el topbar (ADR 048). Un clic avanza el ciclo
 * claro → oscuro → sistema; el ícono refleja la preferencia actual.
 */
export function ThemeToggle() {
  const { preferencia, alternar } = useTheme();
  const { Icono, label } = META[preferencia];
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={alternar}
      aria-label={`${label}. Clic para cambiar de tema.`}
      title={label}
    >
      <Icono className="h-5 w-5" aria-hidden="true" />
    </Button>
  );
}
